/* eslint-disable */
import { IPlugin, IPluginManager } from '../pluginInterface';
import {
    TDWModuleType,
    TDWOperationType,
    TDWActionType,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { MenuType } from '@src/slide/domain/ui-model/constant/menu';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import GroupModel from '@src/slide/domain/ui-model/element-modeles/group-model';
import SlideModel from '@src/slide/domain/ui-model/element-modeles/slide-model';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { IConnectorModel } from '@src/slide/domain/ui-model/element-modeles/Interface/connector-model.interface';
import { UIModelType } from '../../element-modeles/constant';
import { transaction } from '@src/slide/domain/slide-app';
import has from 'lodash/has';

export const ChildActionType = {
    ALIGN: 'adjustAlign',
    HORIZONTALLT_LEFT: 'horizontally-left',
    HORIZONTALLT_CENTER: 'horizontally-center',
    HORIZONTALLT_RIGHT: 'horizontally-right',
    VERTICALLY_TOP: 'vertaically-top',
    VERTICALLY_CENTER: 'vertaically-center',
    VERTICALLY_BOTTOM: 'vertaically-bottom',
    DISTRIBUTE_HORIZONTALLT: 'distribute-horizontally',
    DISTRIBUTE_VERTICALLY: 'distribute-vertically',
    FLOAT_TOOLBAR: 'float-toolbar',
};

export const ChangeArrayType = {
    LEFT: 1,
    TOP: 2,
};
export default class adjustAlign implements IPlugin {
    run(app: IPluginManager, param: any) {
        transaction(() => {
            // 排除未吸附的连接线连接线
            let selection = app.selection().filter((item) => {
                if (item?.type === UIModelType.CONNECTOR
                    && (!!(item as IConnectorModel).startUIModel || !!(item as IConnectorModel).endUIModel)) {
                    return true;
                } else if (item?.type === UIModelType.CONNECTOR) {
                    return false;
                }
                return true;
            });
            let i = selection.length;
            if (i < 1) return;
            // console.log(selection);
            const action: string = param.idParam[0];
            const type: string = param.type;
            let align: AdjustAlignInterface = new AdjustOneSideAlign(action);
            switch (action) {
                case ChildActionType.HORIZONTALLT_LEFT:
                case ChildActionType.HORIZONTALLT_RIGHT:
                case ChildActionType.VERTICALLY_TOP:
                case ChildActionType.VERTICALLY_BOTTOM:
                    align = new AdjustOneSideAlign(action);
                    break;

                case ChildActionType.HORIZONTALLT_CENTER:
                case ChildActionType.VERTICALLY_CENTER:
                    align = new AdjustTwoSideCenterAlign(action);
                    break;

                case ChildActionType.DISTRIBUTE_HORIZONTALLT:
                case ChildActionType.DISTRIBUTE_VERTICALLY:
                    align = new AdjustTwoSideEqualDistaceAlign(action);
                    break;
            }
            const changeArray: Array<any> = [];
            let a = align.calculateCoordinates(selection, changeArray);
            let b = this.adjustConnectors(selection, changeArray);
            this.report(action, type);
            app.updateElements(a.concat(b));
        });
    }

    // update(elements: Array<IElementBaseModel>) {
    // 	let align : AdjustOneSideAlign = new AdjustOneSideAlign(ChildActionType.FLOAT_TOOLBAR);
    // 	align.confirmGroupouterFrameOnSlide(elements);
    // };

    adjustConnectors = (adjustElments: Array<IElementBaseModel | null>, changeArray: Array<any>) => {
        let adjustConnectors: Array<IConnectorModel | null> = [];
        for (const iterator of adjustElments) {
            if (!iterator) {
                continue;
            }
            if (iterator.type === UIModelType.GROUP) {
                this.adjustConnectors(iterator.children as IElementBaseModel[], changeArray);
            }
            let refs: Array<IElementBaseModel | null> = iterator.relatedUIModelRefs;
            if (refs.length) {
                for (const item of refs) {
                    if (item?.type === UIModelType.CONNECTOR && adjustConnectors.indexOf(item as IConnectorModel) < 0) {
                        const connectorModel = item as IConnectorModel;
                        if (connectorModel.startUIModel && connectorModel.endUIModel) {
                            connectorModel.updateLook();
                            adjustConnectors.push(connectorModel);
                        } else {
                            let currentElement = connectorModel.endUIModel === null ? connectorModel.startUIModel : connectorModel.endUIModel;
                            let targetChange = changeArray.find(
                                (element) => element && currentElement && element.key === currentElement.key,
                            );
                            if (targetChange) {
                                if (has(targetChange, 'top')) {
                                    connectorModel.props.style.top += targetChange.top;
                                    adjustConnectors.push(connectorModel);
                                } else if (has(targetChange, 'left')) {
                                    connectorModel.props.style.left += targetChange.left;
                                    adjustConnectors.push(connectorModel);
                                }
                            }
                        }
                    }
                }
            }
        }
        return adjustConnectors;
    };

    report = (action: string, type: string) => {
        tdw({
            opername: TDWOperationType.DOC_PPT,
            module: TDWModuleType.PC_EDIT_ALIGN,
            action: TDWActionType.ALIGN_QUICK_TOTAL,
        });
        switch (action) {
            case ChildActionType.HORIZONTALLT_LEFT:
            case ChildActionType.HORIZONTALLT_RIGHT:
            case ChildActionType.VERTICALLY_TOP:
            case ChildActionType.VERTICALLY_BOTTOM:
                this.reportAlign(type);
                break;

            case ChildActionType.HORIZONTALLT_CENTER:
            case ChildActionType.VERTICALLY_CENTER:
                this.reportCenter(type);
                break;

            case ChildActionType.DISTRIBUTE_HORIZONTALLT:
            case ChildActionType.DISTRIBUTE_VERTICALLY:
                this.reportDistribute(type);
                break;
        }
    };

    reportAlign = (type: string) => {
        switch (type) {
            case MenuType.FLOAT:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_QUICK_RIGHT,
                });
                break;
            case MenuType.POP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_CLICK_RIGHT,
                });
                break;
            case MenuType.TOP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_MENU_RIGHT,
                });
                break;
            case MenuType.TOOLBAR:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_TOOL_RIGHT,
                });
                break;
        }
    };

    reportCenter = (type: string) => {
        switch (type) {
            case MenuType.FLOAT:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_QUICK_MID,
                });
                break;
            case MenuType.POP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_CLICK_MID,
                });
                break;
            case MenuType.TOP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_MENU_MID,
                });
                break;
            case MenuType.TOOLBAR:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_TOOL_MID,
                });
                break;
        }
    };

    reportDistribute = (type: string) => {
        switch (type) {
            case MenuType.FLOAT:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_QUICK_VERTICAL,
                });
                break;
            case MenuType.POP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_CLICK_VERTICAL,
                });
                break;
            case MenuType.TOP_MENU:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_MENU_VERTICAL,
                });
                break;
            case MenuType.TOOLBAR:
                tdw({
                    opername: TDWOperationType.DOC_PPT,
                    module: TDWModuleType.PC_EDIT_ALIGN,
                    action: TDWActionType.ALIGN_TOOL_VERTICAL,
                });
                break;
        }
    };
}

interface AdjustAlignInterface {
    // step1 确认对齐基准线
    confirmBaseLine(element: Array<IElementBaseModel>);

    // step2 排列元素
    arrangeElements: (element: Array<IElementBaseModel>) => Array<IElementBaseModel>;

    // step3 计算新坐标
    calculateCoordinates: (
        element: Array<IElementBaseModel | null>,
        changeArray: Array<any>,
    ) => Array<IElementBaseModel | null>;

    // 暂存坐标变化
    temporaryChang(changeArray: Array<any>, type: number, value: number, element: IElementBaseModel);
}
/**
 * 单边对齐
 */
class AdjustOneSideAlign implements AdjustAlignInterface {
    action: String;

    public constructor(acton: String) {
        this.action = acton;
    }

    sortData = (a: IElementBaseModel, b: IElementBaseModel) => {
        const aOuterFrame = a.getFrame?.().outerFrameOnSlide()
        const bOuterFrame = b.getFrame?.().outerFrameOnSlide()
        let side: number = aOuterFrame.left - bOuterFrame.left;
        switch (this.action) {
            case ChildActionType.HORIZONTALLT_LEFT:
                side = aOuterFrame.left - bOuterFrame.left;
                break;
            case ChildActionType.VERTICALLY_TOP:
                side = aOuterFrame.top - bOuterFrame.top;
                break;
            case ChildActionType.HORIZONTALLT_RIGHT:
                side = aOuterFrame.width + aOuterFrame.left - bOuterFrame.width - bOuterFrame.left;
                break;
            case ChildActionType.VERTICALLY_BOTTOM:
                side = aOuterFrame.top + aOuterFrame.height - bOuterFrame.top - bOuterFrame.height;
                break;
        }
        return side;
    };

    confirmBaseLine(element: Array<IElementBaseModel>) {
        let side = 0;
        if (element.length === 1) {
            //slide对齐
            const slide = getParentSlideModelFromBaseModel(element[0]);
            switch (this.action) {
                case ChildActionType.HORIZONTALLT_LEFT:
                case ChildActionType.VERTICALLY_TOP:
                    side = 0;
                    break;
                case ChildActionType.HORIZONTALLT_RIGHT:
                    side = slide?.width ?? 0;
                    break;
                case ChildActionType.VERTICALLY_BOTTOM:
                    side = slide?.height ?? 0;
                    break;
            }
        } else {
            //元素对齐
            element.sort(this.sortData);
            const lastOuterFrame = element[element.length - 1].getFrame?.().outerFrameOnSlide()
            const firstOuterFrame = element[0].getFrame?.().outerFrameOnSlide()
            switch (this.action) {
                case ChildActionType.HORIZONTALLT_LEFT:
                    side = firstOuterFrame.left;
                    break;
                case ChildActionType.VERTICALLY_TOP:
                    side = firstOuterFrame.top;
                    break;
                case ChildActionType.HORIZONTALLT_RIGHT:
                    side = lastOuterFrame.left + lastOuterFrame.width;
                    break;
                case ChildActionType.VERTICALLY_BOTTOM:
                    side = lastOuterFrame.top + lastOuterFrame.height;
                    break;
            }
        }
        return side;
    }

    confirmGroupouterFrameOnSlide(elements: Array<IElementBaseModel>) {
        let frame = {
            left: elements[0].getFrame().getLeft(),
            top: elements[0].getFrame().getTop(),
            right: elements[0].getFrame().getLeft() + elements[0].getFrame().getWidth(),
            bottom: elements[0].getFrame().getTop() + elements[0].getFrame().getWidth(),
        };
        for (const iterator of elements) {
            frame.left = frame.left < iterator.getFrame().getLeft() ? frame.left : iterator.getFrame().getLeft();
            frame.top = frame.top < iterator.getFrame().getTop() ? frame.top : iterator.getFrame().getTop();
            frame.right = frame.right < iterator.getFrame().getLeft() + iterator.getFrame().getWidth() ? iterator.getFrame().getLeft() + iterator.getFrame().getWidth() : frame.right;
            frame.bottom =
                frame.bottom < iterator.getFrame().getTop() + iterator.getFrame().getHeight() ? iterator.getFrame().getTop() + iterator.getFrame().getHeight() : frame.bottom;
        }
        return frame;
    }

    arrangeElements(element: Array<IElementBaseModel>) {
        return element;
    }
    calculateCoordinates(element: Array<IElementBaseModel>, changeArray: Array<any>) {
        const side: number = this.confirmBaseLine(element);
        let change = 0;
        let type: number = ChangeArrayType.LEFT;
        //遍历重置dide
        if (element.length === 1) {
            let outerFrameOnSlide = element[0].getFrame?.().outerFrameOnSlide();
            switch (this.action) {
                case ChildActionType.HORIZONTALLT_LEFT:
                    change = side - outerFrameOnSlide.left;
                    type = ChangeArrayType.LEFT;
                    element[0].props.style.left += change;
                    break;
                case ChildActionType.VERTICALLY_TOP:
                    change = side - outerFrameOnSlide.top;
                    type = ChangeArrayType.TOP;
                    element[0].props.style.top += change;
                    break;
                case ChildActionType.HORIZONTALLT_RIGHT:
                    change = side - outerFrameOnSlide.width - outerFrameOnSlide.left;
                    type = ChangeArrayType.LEFT;
                    element[0].props.style.left += change;
                    break;
                case ChildActionType.VERTICALLY_BOTTOM:
                    change = side - outerFrameOnSlide.height - outerFrameOnSlide.top;
                    type = ChangeArrayType.TOP;
                    element[0].props.style.top += change;
                    break;
            }
            this.temporaryChang(changeArray, type, change, element[0]);
        } else {
            for (let j = 0, len = element.length; j < len; j++) {
                let outerFrameOnSlide = element[j].getFrame?.().outerFrameOnSlide();
                switch (this.action) {
                    case ChildActionType.HORIZONTALLT_LEFT:
                        change = side - outerFrameOnSlide.left;
                        type = ChangeArrayType.LEFT;
                        element[j].props.style.left += change;
                        break;
                    case ChildActionType.VERTICALLY_TOP:
                        change = side - outerFrameOnSlide.top;
                        type = ChangeArrayType.TOP;
                        element[j].props.style.top += change;
                        break;
                    case ChildActionType.HORIZONTALLT_RIGHT:
                        change = side - outerFrameOnSlide.width - outerFrameOnSlide.left;
                        type = ChangeArrayType.LEFT;
                        element[j].props.style.left += change;
                        break;
                    case ChildActionType.VERTICALLY_BOTTOM:
                        change = side - outerFrameOnSlide.height - outerFrameOnSlide.top;
                        type = ChangeArrayType.TOP;
                        element[j].props.style.top += change;
                        break;
                }
                this.temporaryChang(changeArray, type, change, element[j]);
            }
        }

        return element;
    }

    temporaryChang(changeArray: Array<any>, type: number, value: number, element: IElementBaseModel) {
        if (element.relatedUIModelRefs === null) return;
        switch (type) {
            case ChangeArrayType.LEFT:
                changeArray.push({ left: value, key: element.key });
                break;
            case ChangeArrayType.TOP:
                changeArray.push({ top: value, key: element.key });
                break;
        }
    }
}

/**
 * 双边中线对齐
 */
class AdjustTwoSideCenterAlign implements AdjustAlignInterface {
    action: String;

    constructor(acton: String) {
        this.action = acton;
    }

    sortData = (a: IElementBaseModel, b: IElementBaseModel) => {
        const aFrame = a.getFrame();
        const bFrame = b.getFrame();
        let side: number = aFrame.getLeft() - bFrame.getLeft();
        switch (this.action) {
            case ChildActionType.HORIZONTALLT_CENTER:
                side = aFrame.getLeft() + aFrame.getWidth() / 2 - bFrame.getLeft() - bFrame.getWidth() / 2;
                break;
            case ChildActionType.VERTICALLY_CENTER:
                side = aFrame.getTop() + aFrame.getHeight() / 2 - bFrame.getTop() - bFrame.getHeight() / 2;
                break;
        }
        if (side === 0) {
            side = a.zIndex - b.zIndex;
        }
        return side;
    };

    geMidSide = (element: Array<IElementBaseModel>) => {
        const sides: Array<number> = [];
        element = this.arrangeElements(element);
        switch (this.action) {
            case ChildActionType.HORIZONTALLT_CENTER:
                sides[0] = element[0].getFrame().getLeft(true) + element[0].getFrame().getWidth() / 2;
                sides[1] = element[element.length - 1].getFrame().getLeft(true) + element[element.length - 1].getFrame().getWidth() / 2;
                break;
            case ChildActionType.VERTICALLY_CENTER:
                sides[0] = element[0].getFrame().getTop(true) + element[0].getFrame().getHeight() / 2;
                sides[1] = element[element.length - 1].getFrame().getTop(true) + element[element.length - 1].getFrame().getHeight() / 2;
                break;
        }
        return (sides[0] + sides[1]) / 2;
    };

    confirmBaseLine(element: Array<IElementBaseModel>) {
        let side = -999;
        if (element.length === 1) {
            //slide对齐
            let cur: IBaseModel | null = element[0];
            while (cur && !(cur instanceof SlideModel)) {
                cur = cur.parent;
            }
            if (cur instanceof SlideModel) {
                switch (this.action) {
                    case ChildActionType.HORIZONTALLT_CENTER:
                        side = cur.width / 2;
                        break;
                    case ChildActionType.VERTICALLY_CENTER:
                        side = cur.height / 2;
                        break;
                }
            }
        } else {
            //元素对齐
            side = this.geMidSide(element);
        }
        return side;
    }
    arrangeElements(element: Array<IElementBaseModel>) {
        //元素对齐
        element.sort(this.sortData);
        return element;
    }
    calculateCoordinates(element: Array<IElementBaseModel>, changeArray: Array<any>) {
        const side: number = this.confirmBaseLine(element);
        let change = 0;
        let type: number = ChangeArrayType.LEFT;
        //遍历重置dide
        for (let j = 0, len = element.length; j < len; j++) {
            let outerFrameOnSlide = element[j].getFrame?.().outerFrameOnSlide();
            switch (this.action) {
                case ChildActionType.HORIZONTALLT_CENTER:
                    change = side - outerFrameOnSlide.width / 2 - outerFrameOnSlide.left;
                    element[j].props.style.left += change;
                    break;
                case ChildActionType.VERTICALLY_CENTER:
                    change = side - outerFrameOnSlide.height / 2 - outerFrameOnSlide.top;
                    type = ChangeArrayType.TOP;
                    element[j].props.style.top += change;
                    break;
            }
            this.temporaryChang(changeArray, type, change, element[j]);
        }
        return element;
    }

    temporaryChang(changeArray: Array<any>, type: number, value: number, element: IElementBaseModel) {
        if (element.relatedUIModelRefs === null) return;
        switch (type) {
            case ChangeArrayType.LEFT:
                changeArray.push({ left: value, key: element.key });
                break;
            case ChangeArrayType.TOP:
                changeArray.push({ top: value, key: element.key });
                break;
        }
    }

    changeGroupParent(element, type, value) {
        let p = element.parent || null;
        const parents: Array<IElementBaseModel> = [];
        while (p) {
            if (p instanceof GroupModel) {
                switch (type) {
                    case ChangeArrayType.LEFT:
                        p.props.style.left += value;
                        p.props.style.width += value;
                        break;
                    case ChangeArrayType.TOP:
                        p.props.style.top += value;
                        p.props.style.height += value;
                        break;
                }
                parents.push(p);
            }
            p = p.parent;
        }
        return parents;
    }
}

/**
 * 双边等距对齐
 */
class AdjustTwoSideEqualDistaceAlign implements AdjustAlignInterface {
    action: String;
    constructor(acton: String) {
        this.action = acton;
    }

    sortData = (a: IElementBaseModel, b: IElementBaseModel) => {
        const aFrame = a.getFrame();
        const bFrame = b.getFrame();
        let side: number = aFrame.getLeft() - bFrame.getLeft();
        switch (this.action) {
            case ChildActionType.DISTRIBUTE_HORIZONTALLT:
                side = aFrame.getLeft() + a.getFrame().getWidth() / 2 - bFrame.getLeft() - b.getFrame().getWidth() / 2;
                break;
            case ChildActionType.DISTRIBUTE_VERTICALLY:
                side = aFrame.getTop() + a.getFrame().getHeight() / 2 - bFrame.getTop() - b.getFrame().getHeight() / 2;
                break;
        }
        if (side === 0) {
            side = a.zIndex - b.zIndex;
        }
        return side;
    };

    confirmBaseLine(element: Array<IElementBaseModel>) {
        return element;
    }
    arrangeElements(element: Array<IElementBaseModel>) {
        //元素对齐
        element.sort(this.sortData);
        return element;
    }
    calculateCoordinates(element: Array<IElementBaseModel>, changeArray: Array<any>) {
        if (element.length < 3) {
            //小于3个不做操作
            return element;
        } else {
            element = this.arrangeElements(element);
            let totalDistance = 0;
            let allSizes = 0;
            let averageDistance = 0;
            const lastOuterFrame = element[element.length - 1].getFrame?.().outerFrameOnSlide()
            const firstOuterFrame = element[0].getFrame?.().outerFrameOnSlide()
            // 计算间距
            switch (this.action) {
                case ChildActionType.DISTRIBUTE_HORIZONTALLT:
                    totalDistance = lastOuterFrame.left + lastOuterFrame.width - firstOuterFrame.left;
                    for (let j = 0, len = element.length; j < len; j++) {
                        allSizes += element[j].getFrame?.().outerFrameOnSlide().width;
                    }
                    averageDistance = (totalDistance - allSizes) / (element.length - 1);
                    break;
                case ChildActionType.DISTRIBUTE_VERTICALLY:
                    totalDistance = lastOuterFrame.top + lastOuterFrame.height - firstOuterFrame.top;
                    for (let j = 0, len = element.length; j < len; j++) {
                        allSizes += element[j].getFrame?.().outerFrameOnSlide().height;
                    }
                    averageDistance = (totalDistance - allSizes) / (element.length - 1);
                    break;
            }

            //遍历重置
            const teporaryVariable: Array<number> = [];
            let change = 0;
            let type: number = ChangeArrayType.LEFT;
            for (let j = 1, len = element.length; j < len - 1; j++) {
                const outerFrame = element[j].getFrame?.().outerFrameOnSlide()
                switch (this.action) {
                    case ChildActionType.DISTRIBUTE_HORIZONTALLT:
                        if (teporaryVariable.length === 0) {
                            teporaryVariable[0] = firstOuterFrame.left + firstOuterFrame.width;
                        }
                        change = teporaryVariable[0] + averageDistance - outerFrame.left;
                        element[j].props.style.left += change;
                        teporaryVariable[0] += averageDistance + outerFrame.width;
                        break;
                    case ChildActionType.DISTRIBUTE_VERTICALLY:
                        if (teporaryVariable.length === 0) {
                            teporaryVariable[0] = firstOuterFrame.top + firstOuterFrame.height;
                        }
                        change = teporaryVariable[0] + averageDistance - outerFrame.top;
                        type = ChangeArrayType.TOP;
                        element[j].props.style.top += change;
                        teporaryVariable[0] += averageDistance + outerFrame.height;
                        break;
                }
                this.temporaryChang(changeArray, type, change, element[j]);
            }
            return element;
        }
    }

    temporaryChang(changeArray: Array<any>, type: number, value: number, element: IElementBaseModel) {
        if (element.relatedUIModelRefs === null) return;
        switch (type) {
            case ChangeArrayType.LEFT:
                changeArray.push({ left: value, key: element.key });
                break;
            case ChangeArrayType.TOP:
                changeArray.push({ top: value, key: element.key });
                break;
        }
    }
}

function getParentSlideModelFromBaseModel(cur: IBaseModel | null): SlideModel | null {
    while (cur && !(cur instanceof SlideModel)) {
        cur = cur.parent;
    }
    if (cur instanceof SlideModel) {
        return cur;
    }
    return null;
}

export const testObj = {
    AdjustOneSideAlign,
    AdjustTwoSideCenterAlign,
    AdjustTwoSideEqualDistaceAlign,
};
